import { useQuery } from '@tanstack/react-query';
import { dataService } from '../dataService';
import { queryKeys } from '../queryKeys';
import { queryConfig } from '../queryConfig';

export const useCompanyStats = (companyId: string | undefined, userRole?: string) => {
    const isSuperAdmin = userRole === 'SUPER_ADMIN';
    return useQuery({
        queryKey: queryKeys.companies.stats(companyId ?? null),
        queryFn: () => dataService.getCompanyStats(companyId ?? null),
        enabled: !!companyId || isSuperAdmin,
        ...queryConfig.statistics,
    });
};

export const useVerifiedESALettersStats = (companyId: string | undefined, days: number | 'all' = 30, userRole?: string) => {
    const isSuperAdmin = userRole === 'SUPER_ADMIN';
    return useQuery({
        queryKey: queryKeys.companies.verifiedLetters(companyId ?? null, days),
        queryFn: () => dataService.getVerifiedESALettersStats(companyId ?? null, days),
        enabled: !!companyId || isSuperAdmin,
        ...queryConfig.statistics,
    });
};
